<template>
	<div class="container">

		<el-scrollbar id="menuWarpper" style="height:calc(99%);background-color: #FFFFFF;margin-top: 0px;">
			<div class="main">
				<div class="yonghuminglabe">新建客户账号</div>
				<div class="header-con">
					<div class="maina">
						<el-form :model="form" :rules="formRule" ref="form" label-width="140px" label-position="right"
							style="display: inline">
							<el-row>
								<el-col :span="12">
								
									<el-form-item style="width:100%" label="单位编号：" prop="xuanzekehu">
										<el-input style="width:100%" type="text" v-model="form.xuanzekehu" @focus="XuanXeHouXiuGai"
											@keyup.enter.native="double" placeholder="点回车查询客户单位编号" ref="xuanzekehu"
											@dblclick.native="double" clearable>
										</el-input>
									</el-form-item>
								
								</el-col>
								<el-col :span="12">
								
									<el-form-item style="width:100%" label="客户联系人：" prop="kehuxingming">
										<el-input style="width:100%" type="text" v-model="form.kehuxingming"
											ref="kehuxingming" @keyup.enter.native="xzdanweibianhao"
											placeholder="请输入客户的联系人名称">
										</el-input>
									</el-form-item>
								
								</el-col>
								<el-col :span="12">
									<el-form-item style="width:100%" label="客户账号：" prop="kehuzhanghao">
										<el-input style="width:100%" type="text" v-model="form.kehuzhanghao"
											ref="kehuzhanghao" @keyup.enter.native="xzkehumima" placeholder="请输入客户登录账号">
										</el-input>

									</el-form-item>
								</el-col>
								<el-col :span="12">

									<el-form-item style="width:100%" label="客户密码：" prop="kehumima">
										<el-input style="width:100%" type="text" v-model="form.kehumima" ref="kehumima"
											@keyup.enter.native="xzkehulianxifangshi" placeholder="请输入客户登录的登录密码(修改信息可传空)">
										</el-input>
									</el-form-item>

								</el-col>
								
								<el-col :span="12">

									<el-form-item style="width:100%" label="客户联系方式：" prop="kehulianxifangshi">
										<el-input style="width:100%" type="text" v-model="form.kehulianxifangshi"
											ref="kehulianxifangshi" placeholder="请输入客户的联系方式">
										</el-input>
									</el-form-item>

								</el-col>
								<!-- <el-col :span="12">

									<el-form-item style="width:100%" label="金额：" prop="PAYMENTS">
										<el-input style="width:100%" type="text" v-model="form.PAYMENTS" ref="PAYMENTS"
											placeholder="请输入金额">
										</el-input>
									</el-form-item>

								</el-col>
								<el-col :span="12">

									<el-form-item style="width:100%" label="是否交服务费：" prop="ISBOUGHT">
										<el-radio-group style="width:70%" v-model="form.ISBOUGHT">
											<el-radio :label="0">否</el-radio>
											<el-radio :label="1">是</el-radio>
										</el-radio-group>
										<el-button type="primary" style="width:70px" @click="form.ISBOUGHT=''" :disabled="isTiJiao">清空</el-button>
									</el-form-item>
									
								</el-col>

								<el-col :span="12">

									<el-form-item style="width:100%" label="等级：" prop="SLEVEL">
										<el-radio-group style="width:70%" v-model="form.SLEVEL">
											<el-radio :label="0">A</el-radio>
											<el-radio :label="1">B</el-radio>
											<el-radio :label="2">C</el-radio>
											<el-radio :label="3">D</el-radio>
										</el-radio-group>
										<el-button type="primary" style="width:70px" @click="form.SLEVEL=''" :disabled="isTiJiao">清空</el-button>
									</el-form-item>

								</el-col>
								<el-col :span="12">

									<el-form-item style="width:100%" label="时间区间：" prop="kehulianxifangshi">
										
										<el-date-picker style="width:47%" default-time="00:00:00" value-format="yyyy-MM-dd"
											v-model="form.PAYBEGINDATE" @change="changeRQXZ"
											type="date" placeholder="开始时间">
										</el-date-picker>~
										<el-date-picker style="width:47%" @change="changeRQXZ" default-time="23:59:59" value-format="yyyy-MM-dd"
											v-model="form.PAYENDDATE"
											type="date" placeholder="结束时间">
										</el-date-picker>
										
									</el-form-item>

								</el-col>


								<el-col :span="12">

									<el-form-item style="width:100%" label="备注：" prop="kehulianxifangshi">
										<el-input style="width:100%" type="text" v-model="form.Remark" ref="Remark"
											placeholder="请输入备注">
										</el-input>
									</el-form-item>

								</el-col>
								<el-col :span="12">
									<el-form-item style="width:100%" label="购买产品：" prop="kehulianxifangshi">
										<el-scrollbar
											style="height:350px;background-color: #FFFFFF;border: 1px solid #d9d9d9;border-radius: 6px;padding-left: 10px">
											<el-checkbox :indeterminate="isIndeterminate" v-model="checkAll"
												@change="handleCheckAllChange">全选</el-checkbox>
											<el-checkbox-group v-model="checkedCities"
												@change="handleCheckedCitiesChange">
												<el-checkbox style="width: 80%;" v-for="item in staff"
													:label="item.Code" :key="item.Code">
													{{item.Name}}
												</el-checkbox>
											</el-checkbox-group>
										</el-scrollbar>
									</el-form-item>

								</el-col> -->







								<el-col :span="24">

									<el-button class="tijiaobtn" type="primary" @click="submitForm()"
										:disabled="isTiJiao">提交
									</el-button>
								</el-col>
							</el-row>

						</el-form>

					</div>


				</div>
			</div>
			<el-dialog title="选择客户" :visible.sync="formDialog" width="80%" height="80%">
				<div class="containera">
					<el-card class="headera">
						<div class="header-cona">
							<el-form class="header-con-form" :inline="true" @submit.native.prevent>
								<el-form-item class="header-con-form-item" label="客户姓名:">
									<el-input v-model="form.xuanzekehu" style="width: 200px" placeholder="请输入"
										ref="kehuchaxun" @change="ChaXun(1)" @keyup.enter.native="ChaXun(1)"></el-input>
								</el-form-item>
								<el-button type="primary" @click="ChaXun(1)" :disabled="isChaXun">查询</el-button>
							</el-form>


						</div>
						<div>

						</div>
					</el-card>
					<div class="main" v-bind:style="{height:EchartsHeight}">
						<el-table :data="tableData" height="100%" highlight-current-row resizable stripe border
							@row-dblclick="handledbClick">
							<el-table-column align="center" type="index" label="序号" width="50">
							</el-table-column>
							<el-table-column align="center" prop="BUSINESSNAME" label="客户名称" min-width="180">
							</el-table-column>
							<el-table-column align="center" prop="BUSINESSCODE" label="客户编号">
							</el-table-column>
							<el-table-column align="center" prop="CONTACT" label="客户联系人">
							</el-table-column>
							<el-table-column align="center" prop="TELEPHONE" label="客户联系电话">
							</el-table-column>



							<el-table-column align="center" label="操作" fixed="right">
								<template slot-scope="scope">
									<el-button type="primary" @click="viewDoc(scope)">选择</el-button>

								</template>
							</el-table-column>
						</el-table>
					</div>
					<div class="footer" ref="footer">
						<pagination :allPage="allPage" :pageSize="pageSize" :currIndex="currPage"
							@hanSiChange="hanSiChange" @hanCurrChange="hanCurrChange"></pagination>
					</div>
				</div>
			</el-dialog>
		</el-scrollbar>

	</div>
</template>

<script>
	import PinyinMatch from "pinyin-match";
	export default {
		name: "kehuzhuce",
		data() {
			return {
				SJQJ: "",
				checkAll: false,
				checkedCities: [],
				isIndeterminate: true,
				isTiJiao: false,
				isChaXun: false,
				EchartsHeight: (document.body.clientHeight - 200) + 'px',
				formDialog: false,
				yonghuming: JSON.parse(localStorage.getItem("userInfo")).NAME,
				/**表单 */
				// form: {
				// 	kehuzhanghao: "", //客户账号
				// 	kehumima: "", //客户密码
				// 	juese: "", //角色
				// 	xiafadaoweijiedan: "", //是否下发
				// 	yuanchenggongju: "", //远程工具
				// 	xuanzekehu: "",
				// 	yujiwanchengshijian: "", //预计完成时间
				// 	kehuxingming: "",
				// 	ISBOUGHT: "",
				// 	SLEVEL: "",
				// 	Remark: "",
				// 	PAYBEGINDATE: "",
				// 	PAYENDDATE: ""

				// },
				form: {
					kehuzhanghao: "", //客户账号
					kehumima: "", //客户密码
					juese: "", //角色
					xiafadaoweijiedan: "", //是否下发
					yuanchenggongju: "", //远程工具
					xuanzekehu: "",
					RFID:"",//单位id
					yujiwanchengshijian: "", //预计完成时间
					kehuxingming: "",
				},
				tableData: [],
				currPage: 1,
				pageSize: 50,
				allPage: 0,
				staffcopy: [],
				staff: [], //产品线
				staffz: [], //产品线
				jueseListcopy: [],
				jueseList: [],
				jueseListz: [],
				loading: false, //搜索加载状态
				scoped: false,
				xiafadaoweijiedanList: [{
						Code: "0",
						Name: "否"
					},
					{
						Code: "1",
						Name: "是"
					}
				],
				/*表单规则 */
				formRule: {
					xuanzekehu: [{
						required: true,
						message: "请选择",
						// trigger: "blur"
					}],
					kehumima: [{
						required: true,
						message: "请输入",
						trigger: "blur"
					}],
					kehuzhanghao: [{
						required: true,
						message: "请输入",
						trigger: "blur"
					}],
					kehuxingming: [{
						required: true,
						message: "请输入",
						trigger: "change"
					}],
					person: [{
						required: true,
						message: "请选择",
						trigger: "blur"
					}],
					juese: [{
						required: true,
						message: "请选择",
						trigger: "blur"
					}],

					yuanchenggongju: [{
						required: true,
						message: "请选择",
						trigger: "blur"
					}],
					yujiwanchengshijian: [{
						required: true,
						message: "请选择",
						trigger: "blur"
					}],
					SLEVEL: [{
						required: true,
						message: "请选择",
						trigger: "blur"
					}],
					ISBOUGHT: [{
						required: true,
						message: "请选择",
						trigger: "blur"
					}]

				},
			};
		},

		mounted() {

			this.$nextTick(() => {
				this.$refs.xuanzekehu.focus()
			})

			const that = this;
			window.onresize = () => {
				return (() => {
					window.screenHeight = document.body.clientHeight
					that.EchartsHeight = (window.screenHeight - 200) + 'px'
				})()
			}

			this.getPerson()
			this.getJueSe()
		},
		activated() {
			this.$nextTick(() => {
				this.$refs.xuanzekehu.focus()
			})

			const that = this;
			window.onresize = () => {
				return (() => {
					window.screenHeight = document.body.clientHeight
					that.EchartsHeight = (window.screenHeight - 200) + 'px'
				})()
			}

			this.getPerson()
			this.getJueSe()
		},

		methods: {
			XuanXeHouXiuGai(){
				console.log("选择后修改")
				this.form.kehuxingming = "";
				this.form.RFID="";
				this.form.kehulianxifangshi = "";
				this.form.xuanzekehu = "";
				
			},
			YZfangfa() {
				var reg = /^[1-9]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])$/;
				var regExp = new RegExp(reg);
				if (!regExp.test(this.form.PAYBEGINDATE)) {
					alert("日期格式不正确，正确格式为：2014-01-01");
					return;
				}
				if (this.form.PAYBEGINDATE !== null && this.form.PAYBEGINDATE !== undefined && this.form.PAYBEGINDATE !==
					"" && this.form.PAYENDDATE !== null && this.form.PAYENDDATE !== undefined && this.form.PAYENDDATE !==
					"") {
					this.changeRQXZ()
				}
			},
			YZfangfatwo() {
				var reg = /^[1-9]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])$/;
				var regExp = new RegExp(reg);
				if (!regExp.test(this.form.PAYENDDATE)) {
					alert("日期格式不正确，正确格式为：2014-01-01");
					return;
				}
				if (this.form.PAYBEGINDATE !== null && this.form.PAYBEGINDATE !== undefined && this.form.PAYBEGINDATE !==
					"" && this.form.PAYENDDATE !== null && this.form.PAYENDDATE !== undefined && this.form.PAYENDDATE !==
					"") {
					this.changeRQXZ()
				}
			},
			changeRQXZ() {
				var d1 = Date.parse(this.form.PAYBEGINDATE);
				var d2 = Date.parse(this.form.PAYENDDATE);
				if (
					this.form.PAYBEGINDATE != "" &&
					this.form.PAYENDDATE != "" &&
					d1 > d2
				) {
					this.form.PAYENDDATE = "";
					this.$message({
						type: "warning",
						message: "结束日期不能大于开始日期,请重新选择结束时间",
						duration: "1000",
					});
					return false;
				}

			},
			handleCheckAllChange(val) {
				if (val == true) {
					var arr = [];
					for (var i in this.staff) {
						arr.push(this.staff[i].Code)
					}
					this.checkedCities = arr
				} else {
					this.checkedCities = [];
				}
				this.isIndeterminate = false;
			},
			handleCheckedCitiesChange(value) {
				let checkedCount = value.length;
				this.checkAll = checkedCount === this.staff.length;
				this.isIndeterminate = checkedCount > 0 && checkedCount < this.staff.length;
			},
			//客户双击
			handledbClick(row) {

				var danweibianhao = row.BUSINESSCODE;

				this.form.kehuxingming = row.BUSINESSNAME;
				this.form.RFID=row.BUSINESSID;
				console.log(row.TELEPHONE)
				if (row.TELEPHONE == null || row.TELEPHONE == undefined || row.TELEPHONE == "") {
					this.form.kehulianxifangshi="";
				} else {
					this.form.kehulianxifangshi = row.TELEPHONE;
				}


				this.formDialog = false;
				if (danweibianhao != "") {
					this.form.xuanzekehu = danweibianhao;
					if(this.form.kehuzhanghao==''||this.form.kehuzhanghao==null||this.form.kehuzhanghao==undefined){
						this.form.kehuzhanghao=danweibianhao;
					}
				} else {
					this.form.xuanzekehu = "";
				}
			

			},
			//客户选择
			viewDoc(row) {
				console.log("row.row.TELEPHONE", row.row.TELEPHONE)
				var danweibianhao = row.row.BUSINESSCODE;
				this.form.kehuxingming = row.row.BUSINESSNAME;
				this.form.RFID=row.row.BUSINESSID;
				// this.form.kehulianxifangshi = row.row.TELEPHONE;

				if (row.row.TELEPHONE == null || row.row.TELEPHONE == undefined || row.row.TELEPHONE == "") {
					this.form.kehulianxifangshi="";
				} else {
					this.form.kehulianxifangshi = row.row.TELEPHONE;
				}
				this.formDialog = false;
				if (danweibianhao != "") {
					this.form.xuanzekehu = danweibianhao;
					this.form.xuanzekehu = danweibianhao;
					if(this.form.kehuzhanghao==''||this.form.kehuzhanghao==null||this.form.kehuzhanghao==undefined){
						this.form.kehuzhanghao=danweibianhao;
					}
				} else {
					this.form.xuanzekehu = "";
				}

			},
			//查询客户
			ChaXun(index) {
				this.loading = true;
				this.isChaXun = true;
				this.$request({
						method: "GET",
						url: 'ACCOUNT/GetKhList?khxm=' + encodeURIComponent(this.form.xuanzekehu) +
							"&pageIndex=" + encodeURIComponent(index) + "&pageSize=" + encodeURIComponent(this
								.pageSize)
					})
					.then((res) => {
						this.isChaXun = false;
						this.loading = false;
						if (res.Code == '0' || res.Code == 0) {
							this.tableData = res.Data;
						}
						this.allPage = res.Total;

					})
					.catch((err) => {
						this.isChaXun = false;
						if (err == "Error: Request failed with status code 401") {
							this.$router.push({
								path: "/login",
							});
						}
					});
			},
			double() {
				this.formDialog = true
				this.currPage = 1;
				this.ChaXun(this.currPage)
				this.$nextTick(() => {
					this.$refs.kehuchaxun.focus()
				})
			},
			dianjichanpinxianyc() {
				this.YuanChengGongJuList = this.YuanChengGongJuListz;
			},
			bindSelectChangeyc(val) {

				if (val) {
					this.YuanChengGongJuList = this.YuanChengGongJuListcopy.filter((item) => {
						return PinyinMatch.match(item.Name, val) //(需要过滤的名称，输入的关键词)
					})
				} else {
					this.YuanChengGongJuList = this.YuanChengGongJuListcopy
				}

			},
			dianjichanpinxian() {
				this.staff = this.staffz;
				this.$nextTick(() => {
					this.$refs.juese.focus()
				})
			},


			bindSelectChange(val) {

				if (val) {
					this.staff = this.staffcopy.filter((item) => {
						return PinyinMatch.match(item.Name, val) //(需要过滤的名称，输入的关键词)
					})
				} else {
					this.staff = this.staffcopy
				}

			},
			dianjichanpinxianjs() {
				this.jueseList = this.jueseListz;
				this.$nextTick(() => {
					this.$refs.jueseList.focus()
				})
			},


			bindSelectChangejs(val) {

				if (val) {
					this.jueseList = this.jueseListcopy.filter((item) => {
						return PinyinMatch.match(item.Name, val) //(需要过滤的名称，输入的关键词)
					})
				} else {
					this.jueseList = this.jueseListcopy
				}

			},
			/**获取产品线 */
			// getPerson() {
			// 	this.loading = true;

			// 	this.$request({
			// 			method: "GET",
			// 			url: "Dictionary/GetProducts",
			// 		})
			// 		.then((res) => {
			// 			this.loading = false;
			// 			if (res.Code == '0' || res.Code == 0) {



			// 				this.staff = res.Data;
			// 				this.staffz = res.Data;
			// 				this.staffcopy = this.staff;


			// 				if (this.staff.length > 0) {
			// 					this.form.person = this.staff[0].Code;
			// 				}

			// 			}

			// 		})
			// 		.catch((err) => {
			// 			if (err == "Error: Request failed with status code 401") {
			// 				this.$router.push({
			// 					path: "/login",
			// 				});
			// 			}
			// 		});
			// },
			/**获取产品线 */
			getPerson() {
				this.loading = true;
				this.$request({
						method: "GET",
						url: "Dictionary/GetProducts",
					})
					.then((res) => {
						this.loading = false;
						if (res.Code == '0' || res.Code == 0) {
							this.staff = res.Data;
							this.staffz = res.Data;
							this.staffcopy = this.staff;
						}
					})
					.catch((err) => {
						if (err == "Error: Request failed with status code 401") {
							this.$router.push({
								path: "/login",
							});
						}
					});
			},
			/**获取角色 */
			getJueSe() {
				this.loading = true;

				this.$request({
						method: "GET",
						url: "Dictionary/GetRoles",
					})
					.then((res) => {
						this.loading = false;
						if (res.Code == '0' || res.Code == 0) {



							this.jueseList = res.Data;
							this.jueseListz = res.Data;
							this.jueseListcopy = this.jueseList;

							if (this.jueseList.length > 0) {
								this.form.juese = this.jueseList[0].Code;
							}

						}

					})
					.catch((err) => {
						if (err == "Error: Request failed with status code 401") {
							this.$router.push({
								path: "/login",
							});
						}
					});
			},
			/**提交选项 */
			submitForm() {


				this.$refs.form.validate((valid) => {
					if (valid) {
						
						// var SLEVEL = ""; //服务结束时间
						
						// if (this.form.SLEVEL == '0') {
						// 	SLEVEL = "A";
						// }
						// if (this.form.SLEVEL == '1') {
						// 	SLEVEL = "B";
						// }
						// if (this.form.SLEVEL == '2') {
						// 	SLEVEL = "C";
						// }
						// if (this.form.SLEVEL == '3') {
						// 	SLEVEL = "D";
						// }
						if (this.form.kehuzhanghao.length == 0 || this.form.kehuzhanghao.length > 0 && this.form
							.kehuzhanghao.trim().length == 0) {
							this.$message({
								message: "账号不能为空！",
								type: "error",
							});
						} else if (this.form.kehumima.length == 0) {
							this.$message({
								message: "密码不能为空！",
								type: "error",
							});
						} else if (this.form.kehuxingming.length == 0) {
							this.$message({
								message: "姓名不能为空！",
								type: "error",
							});
						} else {

							this.isTiJiao = true;
							let data = {

								ID: "", //序号
								JOB_NUMBER: "", //客服工号（客户账号注册传空）
								COMPANY_NUMBER: this.form.xuanzekehu, //单位编号
								ACCOUNT: this.form.kehuzhanghao, //账号
								PASSWORD: this.form.kehumima, //密码
								ROLE: "12", //角色（客户账号注册默认12，其它注册需要选择）
								NAME: this.form.kehuxingming, //姓名
								CONTACT_INFORMATION: this.form.kehulianxifangshi, //联系方式
								PRODUCT_LINE: "", //产品线（客户账号注册传空）
								ACCOUNT_STATUS: "2", //账号状态（ 删除0、审核1、启用2、禁用3）
								RFID:this.form.RFID,//来自于列表的BUSINESSID，单位ID
								// BUY_LINE: this.checkedCities.join(','), //购买产品线code，英文逗号隔开
								// ISBOUGHT: this.form.ISBOUGHT, //是否交服务费 0否 1是
								// PAYMENTS: this.form.PAYMENTS, //交费金额
								// PAYBEGINDATE: this.form.PAYBEGINDATE, //服务开始时间
								// PAYENDDATE: this.form.PAYENDDATE, //服务结束时间
								// SLEVEL: SLEVEL, //服务等级 A、B、C、D
								// Remark: this.form.Remark,

							};
							// this.formDialog = true;

							this.scoped = true;

							this.$request({
									method: "post",
									url: "ACCOUNT/Edit",
									data: data,
								})
								.then(() => {
									this.isTiJiao = false;
									this.$message({
										message: "发起成功！",
										type: "success",
									});
									this.form.kehuzhanghao = "";
									this.form.xuanzekehu = "";
									this.form.RFID="";
									this.form.kehumima = "";
									this.form.kehuxingming = "";
									this.form.kehulianxifangshi = "";
									// this.form.SLEVEL = '';
									// this.form.PAYBEGINDATE = "", //服务开始时间
									// 	this.form.PAYENDDATE = "", //服务结束时间
									// 	this.form.ISBOUGHT = '' //是否交服务费 0否 1是
									// this.form.PAYMENTS = '' //交费金额
									// this.checkedCities = []
									// this.$router.push({ path: "weijiekongdan" });

								})
								.catch((err) => {
									this.isTiJiao = false;
									if (err == "Error: Request failed with status code 401") {
										this.$router.push({
											path: "/login",
										});
									}
								});
						}

					}
					// }
				});
			},
			/**重置表单 */
			resetForm() {
				this.$refs.form.resetFields();
			},
			//回车事件
			xzkehumima() {
				this.$nextTick(() => {
					this.$refs.kehumima.focus()
				})
			},
			xzdanweibianhao() {
				this.$nextTick(() => {
					this.$refs.kehuzhanghao.focus()
				})
			},
			xzkehuxingming() {
				this.$nextTick(() => {
					this.$refs.kehuxingming.focus()
				})
			},
			xzkehulianxifangshi() {
				this.$nextTick(() => {
					this.$refs.kehulianxifangshi.focus()
				})
			},
			xzxzjuese() {
				this.$nextTick(() => {
					this.$refs.xzjuese.focus()
				})
			},

			/**分页size改变 */
			hanSiChange(val) {
				this.pageSize = val;
				this.currPage = 1;
				this.ChaXun(this.currPage);
			},
			/**当前页改变 */
			hanCurrChange(val) {
				this.currPage = val;
				this.ChaXun(this.currPage);
			},
			/**刷新表格数据 */
			handleRefresh() {
				this.currPage = 1;
				this.ChaXun(this.currPage);
			},


		},
	};
</script>

<style scoped>
	.container {
		width: 100%;
		height: 100%;
		padding: 10px;
		box-sizing: border-box;
		background-color: #F0F0F0;
	}

	.containera {
		width: 100%;
		height: 100%;
		padding-left: 10px;
		margin-top: -10px;
		box-sizing: border-box;
		background-color: #FFFFFF;
	}

	.header {
		margin-top: 10px;
		margin-bottom: 15px;
		padding-left: 20px;
	}

	.headera {
		margin-bottom: 2px;
	}


	.el-input {
		width: 100px;
	}

	.yonghuminglabe {
		margin-top: 30px;
		margin-left: 30px;
		margin-bottom: 0px;
		display: inline-block;
	}

	/* 主体容器 */
	.main {
		height: 100%;
		overflow: hidden;
		background-color: #fff;
		padding: 0px;
		box-sizing: border-box;
	}

	.tijiaobtn {
		margin-left: 50%;
		margin-top: 10px;
		width: 100px;
		margin-bottom: 20px;
	}

	.header-con {
		margin-left: 50px;
		margin-right: 50px;
		margin-top: 30px;
	}

	.header-cona {
		display: flex;
		align-items: center;
		height: 30px;
		margin-left: 30px;
	}


	.header-con-form {
		display: flex;
		align-items: center;
	}

	.header-con-form-item {
		margin-bottom: 0;
	}


	.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 178px;
		height: 178px;
		line-height: 178px;
		text-align: center;
	}

	.avatar {
		width: 178px;
		height: 178px;
		display: block;
	}

	/* 主体容器 */
	.maina {
		height: 100%;
		/* overflow: hidden; */
		background-color: #fff;
		padding: 10px;
		box-sizing: border-box;
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
	}

	.el-card {
		box-shadow: 0 1px 1px #F5F5F5 !important;
	}

	/deep/.eloption .el-select-dropdown__wrap {
		max-height: 400px !important;
	}

	.el-table {
		overflow-y: auto !important;
		overflow-x: auto !important;
	}
</style>
